import * as z from "zod";

export const completeSelfServeOnboardingV2 = {
  name: "completeSelfServeOnboardingV2" as const,
  input: z.null(),
  output: z.null(),
};
